
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.583 5.667c0-.88.713-1.584 1.584-1.584h2.375v1.584H8.167v2.375H6.583V5.667zm15.834 0v2.375h-1.584V5.667h-2.375V4.083h2.375a1.583 1.583 0 011.584 1.584zm-1.584 12.666v-2.375h1.584v2.375c0 .88-.713 1.584-1.584 1.584h-2.375v-1.584h2.375zm-14.25 0v-2.375h1.584v2.375h2.375v1.584H8.167a1.583 1.583 0 01-1.584-1.584zm6.334-14.25h3.166v1.584h-3.166V4.083zm0 14.25h3.166v1.584h-3.166v-1.584zm7.916-7.916h1.584v3.166h-1.584v-3.166zm-14.25 0h1.584v3.166H6.583v-3.166z"}}),_c('path',{attrs:{"fill":"#fff","d":"M18 15h5v5h-5z"}}),_c('path',{attrs:{"d":"M23.467 18.5a2.975 2.975 0 00-2.967-2.967 2.975 2.975 0 00-2.967 2.967 2.975 2.975 0 002.967 2.967 2.975 2.975 0 002.967-2.967zm-1.136 1.352l-3.186-3.186c.364-.29.832-.45 1.355-.45a2.29 2.29 0 012.283 2.284c0 .492-.183.96-.452 1.352zM18.217 18.5c0-.523.159-.991.45-1.355l3.188 3.189c-.364.29-.832.45-1.355.45a2.29 2.29 0 01-2.283-2.284z","fill":"#BF360C","stroke":"#BF360C","stroke-width":".1"}})])
          )
        }
      }
    